import { useEffect } from 'react';
import { useTranslate } from '~/i18n';

const TamaraWidgetV2 = ({
   price,
   customContent,
}: {
   price: string | number;
   customContent?: React.ReactElement | React.ReactNode;
}) => {
   const { locale } = useTranslate();
   useEffect(() => {
      (window as any).tamaraWidgetConfig = {
         lang: locale,
         country: 'SA',
         publicKey: process.env.NEXT_PUBLIC_TAMARA_KEY,
      };
   }, [locale]);

   setTimeout(() => {
      if (typeof window !== 'undefined') (window as any)?.TamaraWidgetV2?.refresh();
   }, 100);

   return (
      <div className="p-4 border rounded-lg">
         <tamara-widget type="tamara-summary" amount={price} inline-type="2" inline-variant="text">
            {customContent ? customContent : ''}
         </tamara-widget>
      </div>
   );
};
export default TamaraWidgetV2;
